<i18n src='../i18n/main.json'></i18n>
<i18n src='../i18n/vendors.json'></i18n>
<template>
<div id="properties" style="position: relative">
  <!-- <flash-message variant="success"></flash-message> -->
  <h1>{{$t('vendors')}}</h1>

  <button v-on:click="loadVendorEditor(null, true)" class="btn btn-warning new">{{$t('new_vendor')}}</button>

  <sweet-modal ref="edit_vendor_modal">
    <h2>{{e_vendor_new == true ? $t('new_vendor') : $t('edit') }}</h2>
    <div class="row">
      <div class="form-group col-md-2">
        <label for="e_vendor_name">{{$t('name')}}</label>
        <input id="e_vendor_name" v-model="e_vendor.name" placeholder="" class="form-control">
        <!-- <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small> -->
      </div>

      <div class="form-group col-md-2">
        <label for="e_vendor_mobile">{{$t('mobile')}}</label>
        <input id="e_vendor_mobile" v-model="e_vendor.mobile" placeholder="" class="form-control">
      </div>

      <div class="form-group col-md-2">
        <label for="e_vendor_phone">{{$t('phone')}}</label>
        <input id="e_vendor_phone" v-model="e_vendor.phone" placeholder="" class="form-control">
      </div>

      <div class="form-group col-md-2">
        <label for="e_vendor_fax">{{$t('fax')}}</label>
        <input id="e_vendor_fax" v-model="e_vendor.fax" placeholder="" class="form-control">
      </div>

      <div class="form-group col-md-2">
        <label for="e_vendor_tax_number">{{$t('tax_number')}}</label>
        <input id="e_vendor_tax_number" v-model="e_vendor.tax_number" placeholder="" class="form-control">
      </div>

      <div class="form-group col-md-2" style="text-align: center;">
        <label for="e_vendor_vat_flag">{{$t(e_vendor.vat_flag ? 'calc_vat' : 'no_vat')}}</label>
        <input type="checkbox" id="e_vendor_vat_flag" v-model="e_vendor.vat_flag" class="form-control">
      </div>

    </div>
    <div class="row">
      <div class="form-group col-md-3">
        <label for="e_vendor_address">{{$t('address')}}</label>
        <textarea id="e_vendor_address" v-model="e_vendor.address" placeholder="" class="form-control"></textarea>
      </div>

      <div class="form-group col-md-3">
        <label for="e_vendor_postal_address">{{$t('postal_address')}}</label>
        <textarea id="e_vendor_postal_address" v-model="e_vendor.postal_address" placeholder="" class="form-control"></textarea>
      </div>

      <div class="form-group col-md-3">
        <label for="e_vendor_location">{{$t('location')}}</label>
        <select v-model="e_vendor.location_id" class="form-control">
          <option v-for="(option, key) in locations" :value="option.id">{{$t(option.name)}}</option>
        </select>
      </div>

      <div class="form-group col-md-1">
        <label for="e_vendor_zipcode">{{$t('zipcode')}}</label>
        <input dir="ltr" id="e_vendor_zipcode" v-model="e_vendor.zipcode" placeholder="" class="form-control">
      </div>


    </div>
    <div class="row">


      <div class="form-group col-md-3">
        <label for="e_vendor_contacts">{{$t('contacts')}}</label>
        <textarea id="e_vendor_contacts" v-model="e_vendor.contacts" placeholder="" class="form-control"></textarea>
      </div>

      <div class="form-group col-md-4">
        <label for="e_vendor_notes">{{$t('notes')}}</label>
        <textarea id="e_vendor_notes" v-model="e_vendor.notes" placeholder="" class="form-control"></textarea>
      </div>


    </div>
    <div class="form-group">
      <button class='btn btn-success' v-on:click="save_vendor">{{$t('save')}}</button>
    </div>
  </sweet-modal>


  <form v-on:submit.prevent class="form-inline">
    <div class="form-group">
      <label class="form-label" for="page_number">تصفح</label>
      <button v-on:click="pagination.page_number -= 1; loadvendors();" :disabled="pagination.page_number == 1" class="btn btn-default">-</button>
      <input name="page_number" style="width: 70px;text-align: center;" v-on:keyup="keymonitor" type="text" :max="pagination.total_pages"
        v-model="pagination.page_number" :disabled=PageSelectisDisabled class="form-control center">
      <button v-on:click="pagination.page_number += 1; loadvendors();" :disabled="pagination.total_pages == pagination.page_number"
        class="btn btn-default">+</button>
    </div>

    <div class="form-group">
      <label class="form-label" for="filter_name">{{$t('name')}}</label>
      <input id="filter_name" type="text" v-model="filter.name" class="form-control">
    </div>

    <div class="form-group">
      <label class="form-label" for="filter_mobile">{{$t('mobile')}}</label>
      <input style="width: 100px;" id="filter_mobile" type="text" v-model="filter.mobile" class="form-control">
    </div>
    <div class="form-group">
      <label class="form-label" for="filter_phone">{{$t('phone')}}</label>
      <input style="width: 100px;" id="filter_phone" type="text" v-model="filter.phone" class="form-control">
    </div>
    <div class="form-group">
      <label class="form-label" for="filter_email">{{$t('email')}}</label>
      <input style="width: 100px;" id="filter_email" type="text" v-model="filter.email" class="form-control">
    </div>
    <div class="form-group">
      <label class="form-label" for="filter_tax_number">{{$t('tax_number')}}</label>
      <input style="width: 100px;" id="filter_tax_number" type="text" v-model="filter.tax_number" class="form-control">
    </div>

    <div class="form-group">
      <label for="e_client_location">{{$t('location')}}</label>
      <select v-model="filter.location_id" class="form-control">
        <option v-for="(option, key) in locations" :value="option.id">{{$t(option.name)}}</option>
      </select>
    </div>


    <div class="form-group">
      <div class="totalPages">
        {{ totalPages }}
      </div>
    </div>
    <div class="form-group">
      <label class="form-label" for="per_page">نتائج في كل صفحة</label>
      <select style="width: 100px;" name="per_page" v-model="pagination.per_page" class="form-control center">
        <option disabled value="">נא לבחור אפשרות</option>
        <option>10</option>
        <option>25</option>
        <option>50</option>
        <option>100</option>
      </select>
    </div>
  </form>
  <br />
  <!-- <input type="text" v-model="filter.inserted_at" id="date"> -->
  <!-- <p>רשום במערכת כ- { logged_in_email }</p> -->
  <div style="overflow-x:auto">
    <table class="table listing table-striped">
      <thead>
        <tr class="bg alpha">
          <!-- <th style="width:100px;">{{$t('number')}}</th> -->

          <th>{{$t('name')}}</th>
          <th>{{$t('mobile')}}</th>
          <th>{{$t('phone')}}</th>
          <th>{{$t('location')}}</th>
          <th>{{$t('tax_number')}}</th>
          <th>{{$t('notes')}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="vendor of vendors" :key="vendor.id" v-bind:class="{ pending: vendor.status == 0, approved: vendor.status == 2 }"
          v-tooltip="{content: vendorTooltip(vendor), classes: ['static_tooltip']}">
          <!-- <td>{{ vendor.id }}</td> -->
          <td>
            <i :title="$t('edit')" v-on:click="loadVendorEditor(vendor, false)" class="ti-pencil"></i>
            <span>&rlm;&nbsp;{{ vendor.name }}</span>
          </td>

          <td>{{ vendor.mobile }}</td>
          <td>{{ vendor.phone }}</td>
          <td>{{ vendor.location ? vendor.location.name : ''}}</td>
          <td>{{ vendor.tax_number }}</td>
          <td>{{ vendor.notes }}</td>
        </tr>
        </tr>
      </tbody>
    </table>
  </div>
</div>
</template>

<script>
import { SweetModal } from 'sweet-modal-vue'

export default {
  components: {
    SweetModal
  },
  data() {
    return {
      locations: [],
      adding_item: false,
      e_vendor: [],
      e_vendor_new: false,
      vendors: [],
      errors: [],
      filter: {
        name: '',
        mobile: '',
        phone: '',
        fax: '',
        email: '',
        tax_number: '',
        inserted_at: '2017-10-01',
        location_id: null
      },
      filter_objects: [],
      config: {
        format: 'YYYY-MM-DD',
        useCurrent: false
      },
      pagination: {
        page_number: '',
        total_pages: '',
        per_page: '100'
      },
      PageSelectisDisabled: false
    }
  },
  computed: {
    tokenState() {
      return this.$ls.get('access_token')
    },
    totalPages() {
      return this.pagination.total_pages
    },
    Agent() {
      return this.$ls.get('agent')
    },
    locale() {
      return this.$store.getters.locale
    }
  },
  // Fetches posts when the component is created.
  created() {
    this.init()
    this.loadvendors()
    this.$i18n.locale = this.$store.getters.locale
    this.$i18n.silentTranslationWarn = true
    this.loadTranslations()
    this.load_locations()
    //  this.loadFilterObjects()
  },
  watch: {
    locale(locale) {
      this.$i18n.locale = locale
      this.loadTranslations()
    },
    'filter.name': function(val, oldVal) {
      this.loadvendors()
    },
    'filter.mobile': function(val, oldVal) {
      this.loadvendors()
    },
    'filter.phone': function(val, oldVal) {
      this.loadvendors()
    },
    'filter.fax': function(val, oldVal) {
      this.loadvendors()
    },
    'filter.email': function(val, oldVal) {
      this.loadvendors()
    },
    'filter.tax_number': function(val, oldVal) {
      this.loadvendors()
    },
    'filter.location_id': function(val, oldVal) {
      this.loadvendors()
    },
    // 'filter.vendor_id': function(val, oldVal) {
    //   this.loadvendors()
    // },
    // 'filter.user_id': function(val, oldVal) {
    //   this.loadvendors()
    // },
    // 'pagination.per_page': function(val, oldVal) {
    //   this.loadvendors()
    // },
    items: function(val, oldVal) {
      this.PageSelectisDisabled = false
    }
  },

  methods: {
    vendorTooltip: function(vendor) {
      return `
      Name: ${vendor.name}  <br />
      ID: ${vendor.id}
      `
    },
    loadvendors: function(e) {
      this.PageSelectisDisabled = true
      this.$axios
        .get(`/api/vendors`, {
          headers: this.authorization(),
          params: {
            page: this.pagination.page_number,
            per_page: this.pagination.per_page,
            name: this.filter.name,
            mobile: this.filter.mobile,
            phone: this.filter.phone,
            email: this.filter.email,
            tax_number: this.filter.tax_number,
            location_id: this.filter.location_id,
            inserted_at: this.filter.inserted_at + ' 00:00:00'
          }
        })
        .then(response => {
          console.log(response.data)
          // JSON responses are automatically parsed.
          this.vendors = response.data.vendors.entries

          this.pagination.page_number = response.data.vendors.page_number
          this.pagination.total_pages = response.data.vendors.total_pages
          if (this.pagination.page_number > this.pagination.total_pages) {
            this.pagination.page_number = 1
            this.loadvendors()
          }
        })
        .catch(e => {
          this.errors.push(e)
          this.PageSelectisDisabled = false
        })
    },
    load_locations: function() {
      if (this.locations === undefined || this.locations.length == 0) {
        console.log('locations list is empty, let us load it from remote server..')
        var vm = this
        this.$axios
          .get(`/api/locations`, {
            headers: this.authorization(),
            params: null
          })
          .then(response => {
            console.log(response.data.data)
            vm.locations = response.data.data
            //vm.new_book.language_id = 1
            // JSON responses are automatically parsed.
          })
          .catch(e => {
            this.errors.push(e)
            //this.PageSelectisDisabled = false
          })
      }
    },
    loadVendorEditor: function(vendor, status) {
      this.e_vendor_new = status
      //this.load_languages()
      if (vendor == null) {
        vendor = { name: '', mobile: '' }
      }
      this.e_vendor = vendor
      this.e_vendor.vat_flag = this.e_vendor.vat_flag == 'yes' ? true : false
      console.log(this.e_vendor)
      this.$refs.edit_vendor_modal.open()
    },
    loadTranslations: function() {
      this.click_to_print_sticker = this.$t('click_to_print_sticker')
      this.number_of_results_pages = this.$t('number_of_results_pages')
      this.days_count = this.$t('days_count')
    },
    init: function() {
      //   this.logged_in_email = this.logged_in().as != null ? this.logged_in().as : "Guest"
    },
    keymonitor: function(event) {
      //console.log(event.key)
      if (event.key == 'Enter') {
        this.loadvendors()
      }
    },
    save_vendor: function() {
      this.e_vendor_new == true ? this.create_vendor() : this.update_vendor()
    },
    create_vendor: function() {
      console.log('create_vendor..')
      var vm = this
      var vendor = this.e_vendor
      // vendor.vat_flag = vendor.vat_flag ? 1 : 0
      console.log(this.e_vendor)
      this.$axios
        .post(
          `/api/vendors`,
          {
            vendor
          },
          {
            headers: this.authorization()
          }
        )
        .then(response => {
          console.log(response)
          vm.$refs.edit_vendor_modal.close()
          this.loadvendors()
        })
        .catch(e => {
          this.errors.push(e)
          this.PageSelectisDisabled = false
        })
    },
    update_vendor: function() {
      console.log('update_vendor..')
      var vm = this
      var vendor = this.e_vendor
      // vendor.vat_flag = vendor.vat_flag ? 1 : 0
      console.log(this.e_vendor)
      this.$axios
        .put(
          `/api/vendors/` + vendor.id,
          {
            vendor
          },
          {
            headers: this.authorization()
          }
        )
        .then(response => {
          console.log(response)
          vm.$refs.edit_vendor_modal.close()
          this.loadvendors()
        })
        .catch(e => {
          this.errors.push(e)
          this.PageSelectisDisabled = false
        })
    },

    loadFilterObjects: function(e) {
      this.$axios
        .get(`/api/vendors/filter_objects`, {
          headers: {
            authorization: this.$ls.get('access_token')
          }
        })
        .then(response => {
          // JSON responses are automatically parsed.
          this.filter_objects = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    updateRow: function(row) {
      var foundIndex = this.properties.findIndex(x => x.id == row.id)
      this.$set(this.properties, foundIndex, row)
    }
  }
}
</script>

<style lang="scss">
@import './sass/vendors.scss';
</style>